module.exports = __webpack_public_path__ + "static/bg-image-building-1f91eb632fb9bcd93766038fa7b547c1.jpg";